module.exports = __webpack_public_path__ + "media/overhoren.d183c725.mp4";